"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.parsers = exports.DescriptionItem = void 0;
var _react = _interopRequireWildcard(require("react"));
var _DescriptionContext = _interopRequireDefault(require("./DescriptionContext"));
var _DescriptionValue = _interopRequireDefault(require("./DescriptionValue"));
var _layouts = require("./layouts");
var _parsers = require("./parsers");
var _get = _interopRequireDefault(require("lodash/get"));
var _isNil = _interopRequireDefault(require("lodash/isNil"));
var _isString = _interopRequireDefault(require("lodash/isString"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Stack = _interopRequireDefault(require("../Stack"));
var _Link = _interopRequireDefault(require("../Link"));
var _Typography = _interopRequireDefault(require("../Typography"));
var _Icon = require("../Icon");
var _jsxRuntime = require("react/jsx-runtime");
var _excluded = ["data", "stripEmpty"],
  _excluded2 = ["dense", "disableGutters", "valueGutters", "termWidth", "variant", "label", "field", "type", "valueParser", "onValueClick", "value", "placeholder", "zeroMinWidth", "textVariant", "itemProps", "collapsable", "initialOpen", "showLabel", "hideLabel"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
var parsers = exports.parsers = {
  commaList: _parsers.commaListParser,
  minMaxToStringArray: _parsers.minMaxToStringArrayParser
};
var DescriptionItem = exports.DescriptionItem = function DescriptionItem(props) {
  var _value;
  var _useContext = (0, _react.useContext)(_DescriptionContext["default"]),
    data = _useContext.data,
    stripEmpty = _useContext.stripEmpty,
    contextProps = _objectWithoutProperties(_useContext, _excluded);
  var _props$dense = props.dense,
    dense = _props$dense === void 0 ? contextProps.dense : _props$dense,
    _props$disableGutters = props.disableGutters,
    disableGutters = _props$disableGutters === void 0 ? contextProps.disableGutters : _props$disableGutters,
    valueGutters = props.valueGutters,
    _props$termWidth = props.termWidth,
    termWidth = _props$termWidth === void 0 ? contextProps.termWidth : _props$termWidth,
    _props$variant = props.variant,
    variant = _props$variant === void 0 ? contextProps.variant : _props$variant,
    label = props.label,
    field = props.field,
    _props$type = props.type,
    typeProp = _props$type === void 0 ? 'text' : _props$type,
    valueParser = props.valueParser,
    onValueClick = props.onValueClick,
    valueProp = props.value,
    placeholder = props.placeholder,
    zeroMinWidth = props.zeroMinWidth,
    textVariant = props.textVariant,
    itemProps = props.itemProps,
    _props$collapsable = props.collapsable,
    collapsable = _props$collapsable === void 0 ? false : _props$collapsable,
    _props$initialOpen = props.initialOpen,
    initialOpen = _props$initialOpen === void 0 ? true : _props$initialOpen,
    _props$showLabel = props.showLabel,
    showLabel = _props$showLabel === void 0 ? 'Show' : _props$showLabel,
    _props$hideLabel = props.hideLabel,
    hideLabel = _props$hideLabel === void 0 ? 'Hide' : _props$hideLabel,
    otherProps = _objectWithoutProperties(props, _excluded2);
  var _useState = (0, _react.useState)(initialOpen),
    _useState2 = _slicedToArray(_useState, 2),
    open = _useState2[0],
    setOpen = _useState2[1];
  var value = valueProp;
  var type = typeProp;
  var valueProps = otherProps;
  if (textVariant) {
    valueProps.variant = textVariant;
  }
  if (value === undefined && field) {
    value = (0, _get["default"])(data, field);
    if (valueParser && value !== undefined) {
      value = (0, _isString["default"])(valueParser) ? parsers[valueParser](value) : valueParser(value);
    }
  }
  var isEmpty = (0, _isNil["default"])(value) || ((_value = value) === null || _value === void 0 ? void 0 : _value.length) === 0;
  if (isEmpty) {
    if (placeholder) {
      // render placeholder for empty value
      if ((0, _isString["default"])(placeholder)) {
        value = placeholder;
        type = 'text';
        valueProps = {};
      } else {
        type = function type() {
          return placeholder;
        };
      }
    } else if (stripEmpty) {
      // omit empty item without placeholder
      return null;
    }
  }
  if (!field && isEmpty) {
    throw new Error("DescriptionItem: \"value\" or \"field\" must be provided");
  }
  var handelValueClick = function handelValueClick(e) {
    return onValueClick(e, value);
  };
  var description = /*#__PURE__*/(0, _jsxRuntime.jsx)(_DescriptionValue["default"], _objectSpread({
    value: value,
    type: type,
    onClick: onValueClick && handelValueClick,
    variantView: variant
  }, valueProps));
  var factory;
  switch (variant) {
    case 'row':
      factory = _layouts.Row;
      break;
    case 'column':
      factory = _layouts.Column;
      break;
    default:
      throw new Error("unknown variant (".concat(variant, ")"));
  }
  var handleOpenToggle = function handleOpenToggle() {
    setOpen(function (state) {
      return !state;
    });
  };
  return /*#__PURE__*/(0, _react.createElement)(factory, {
    label: label,
    disableGutters: disableGutters,
    valueGutters: valueGutters,
    dense: dense,
    termWidth: termWidth,
    zeroMinWidth: zeroMinWidth,
    itemProps: _objectSpread({
      'data-cy': 'DescriptionItem',
      'data-cy-label': label
    }, itemProps)
  }, collapsable ? /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Stack["default"], {
    spacing: 1,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Stack["default"], {
      direction: 'row',
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Link["default"], {
        onClick: handleOpenToggle,
        underline: 'none',
        children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Stack["default"], {
          direction: 'row',
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Typography["default"], {
            children: open ? hideLabel : showLabel
          }), open ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.ExpandLessIcon, {
            fontSize: 'small'
          }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.ExpandMoreIcon, {
            fontSize: 'small'
          })]
        })
      })
    }), open ? description : null]
  }) : description);
};
DescriptionItem.propTypes = {
  label: _propTypes["default"].string,
  field: _propTypes["default"].string,
  onValueClick: _propTypes["default"].func,
  valueParser: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].func]),
  placeholder: _propTypes["default"].any,
  type: _propTypes["default"].oneOfType([_propTypes["default"].oneOf(['decimalRange', 'decimal', 'link', 'text', 'status', 'metadata', 'date', 'dateRange', 'amount', 'percent', 'typographyList']), _propTypes["default"].func]),
  value: _propTypes["default"].any,
  disableGutters: _propTypes["default"].bool,
  zeroMinWidth: _propTypes["default"].bool,
  dense: _propTypes["default"].bool,
  termWidth: _propTypes["default"].string,
  variant: _propTypes["default"].oneOf(['row', 'column'])
};